import { useQuery } from "@tanstack/react-query"
import { Checkbox, Dropdown, Input } from "antd"
import { ItemType } from 'antd/lib/menu/hooks/useItems'
import { getFilterList } from "api/Inventory"
import Loader from "helper/Loader"
import React, { useState, useRef, useEffect } from 'react'
import Down from 'helper/Icons/DownIcon'

const OrganizationFilter = ({ filters, setFilters }: any) => {
  const [selectedOrganization, setSelectedOrganization] = useState([])
  const [open, setOpen] = useState(0)
  const [searchTerm, setSearchTerm] = useState('')
  const dropdownRef = useRef<HTMLDivElement | null>(null)
  const { data, refetch } = useQuery(['getFilterList'], () => getFilterList(), {
    enabled: false,
  })

  useEffect(() => {
    refetch()
  }, [])

  const clear = (item, setFn) => {
    if (item in filters) {
      const { [item]: _, ...updatedFilters } = filters
      setFilters(updatedFilters)
    }
    setFn && setFn([])
  }

  const handleDropdownClick = e => {
    e.stopPropagation()
  }

  const checkboxOptions = data?.organizations?.map(item => ({
    label: (
      <div>
        <h4 className="text-14 ml-20px">{item.name}</h4>
      </div>
    ),
    value: item.id,
  }))

  const filteredCheckboxOptions = checkboxOptions?.filter(option =>
    option.label.props.children.props.children
      .toLowerCase()
      .includes(searchTerm.toLowerCase()),
  )

  const handleOrganizationChange = selectedValues => {
    setSelectedOrganization(selectedValues)
  }
  const OrganizationType: ItemType[] = [
    data !== undefined
      ? {
        key: '0',
        label: (
          <div>
            <Input
              placeholder="Search..."
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value)}
              style={{ marginBottom: '10px' }}
            />
            <Checkbox.Group
              options={filteredCheckboxOptions}
              className="category-checkbox"
              value={selectedOrganization}
              onChange={handleOrganizationChange}
            />
            <div className="flex justify-between mx-15px mt-10px">
              <button
                className="clr-btn"
                onClick={() => {
                  clear('organizationIds', setSelectedOrganization)
                  setFilters(prev => {
                    const { organizationIds, ...rest } = prev
                    return rest
                  })
                }}
              >
                Clear
              </button>
              <button
                onClick={() => {
                  setFilters(prev => ({
                    ...prev,
                    organizationIds: selectedOrganization,
                  }));
                  setOpen(0);
                }}
                className="aply-btn"
              >
                Apply
              </button>
            </div>
          </div>
        ),
      }
      : {
        key: '0',
        label: (
          <div>
            <Loader />
          </div>
        ),
      },
  ]



  return (
    <div
      ref={dropdownRef}
      onClick={handleDropdownClick}
    >
      <Dropdown
        menu={{
          items: OrganizationType,
        }}
        placement="bottomLeft"
        arrow={false}
        className="mr-10px"
        onOpenChange={(flag) => setOpen(flag ? 3 : 0)}
        open={open === 3}
        overlayStyle={{ width: '360px' }}
        overlayClassName="custom-dropdown-overlay"
      >
        <button
          className={` ${open === 3 ? 'filter-btn-click' : 'filter-btn'
            } w-500`}
          onClick={() => {
            setOpen(open === 3 ? 0 : 3)
          }}
          style={{ cursor: 'pointer' }}
        >
          Organization <Down />
        </button>
      </Dropdown>
    </div>
  )
}

export default OrganizationFilter